import styled from 'styled-components';

export const ReviewContainer = styled.article`
  padding: 25px 0 25px 0;
  width: 100%;
  
  border-top: 1px solid #ebebeb;
  border-bottom: 1px solid #ebebeb;
`;

export const ReviewHeaderWrapper = styled.div`
  display: flex;
  justify-content: space-between;
  margin-bottom: 15px;
`;
